import React, { useEffect, useState } from "react";
import http from "../lib/http";

export default function AdminReviewsPage() {

  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReviews = async () => {
    try {

      setLoading(true);

      const res = await http.get(
        "/api/dealers/reviews/pending"
      );

      setReviews(res.data || []);

    } catch (err) {

      console.error(
        "Failed to fetch reviews",
        err
      );

    } finally {

      setLoading(false);

    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  // APPROVE
  const approveReview = async (reviewId) => {

    try {

      await http.patch(
        `/api/dealers/reviews/${reviewId}/approve`,
        {
          approved: true
        }
      );

      setReviews(prev =>
        prev.filter(r => r._id !== reviewId)
      );

    } catch (err) {

      console.error(err);
      alert("Failed to approve review");

    }
  };

  // DELETE
  const deleteReview = async (reviewId) => {

    const confirmDelete =
      window.confirm(
        "Delete this review?"
      );

    if (!confirmDelete) return;

    try {

      await http.delete(
        `/api/dealers/reviews/${reviewId}`
      );

      setReviews(prev =>
        prev.filter(r => r._id !== reviewId)
      );

    } catch (err) {

      console.error(err);
      alert("Failed to delete review");

    }
  };

  const renderStars = (rating) => {

    return (
      <div className="text-warning fs-5">
        {"★".repeat(rating || 0)}
        {"☆".repeat(5 - (rating || 0))}
      </div>
    );
  };

  return (
    <div className="container-fluid">

      {/* PAGE HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">

        <div>
          <h3 className="fw-bold mb-1">
            Review Moderation
          </h3>

          <p className="text-muted mb-0">
            Approve or remove customer reviews
          </p>
        </div>

        <div className="badge bg-warning text-dark fs-6 px-3 py-2">
          Pending: {reviews.length}
        </div>

      </div>

      {/* LOADING */}
      {loading && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary"></div>
        </div>
      )}

      {/* EMPTY */}
      {!loading && reviews.length === 0 && (

        <div className="card shadow-sm border-0 text-center py-5">

          <h5 className="text-muted">
            No pending reviews
          </h5>

        </div>
      )}

      {/* REVIEWS */}
      {!loading && reviews.length > 0 && (

        <div className="row g-4">

          {reviews.map((review) => (

            <div
              className="col-lg-6"
              key={review._id}
            >

              <div className="card shadow-sm border-0 h-100">

                <div className="card-body">

                  <div className="d-flex justify-content-between align-items-start mb-3">

                    <div>

                      <h5 className="fw-bold mb-1">
                        {review.dealerName}
                      </h5>

                      {renderStars(review.rating)}

                    </div>

                    <span className="badge bg-warning text-dark">
                      Pending
                    </span>

                  </div>

                  <div className="bg-light rounded p-3 mb-3">

                    <p className="mb-0">
                      {review.comment || "No comment"}
                    </p>

                  </div>

                  <div className="small text-muted mb-3">

                    {new Date(
                      review.date
                    ).toLocaleDateString()}

                  </div>

                  <div className="d-flex gap-2">

                    <button
                      className="btn btn-success flex-grow-1"
                      onClick={() =>
                        approveReview(review._id)
                      }
                    >
                      Approve
                    </button>

                    <button
                      className="btn btn-outline-danger flex-grow-1"
                      onClick={() =>
                        deleteReview(review._id)
                      }
                    >
                      Delete
                    </button>

                  </div>

                </div>

              </div>

            </div>

          ))}

        </div>
      )}

    </div>
  );
}